<template>
  <path pid="0" d="M13.71 22.82L22.55 14a6.5 6.5 0 10-9.2-9.19l-.35.33-.35-.35A6.5 6.5 0 003.45 14l8.84 8.84a1 1 0 001.42-.02zM4.87 6.2a4.51 4.51 0 016.36 0l1.06 1.06a1 1 0 001.42 0l1.06-1.06a4.5 4.5 0 016.36 6.37l-1.06 1.06L13 20.7l-8.13-8.13a4.5 4.5 0 010-6.37z"/>
</template>
